import { Component } from '@angular/core';
import { ConfigService } from '../../client-config/services/config.service';
import { LocalizeContacts } from '../../../core/shared/localize-config';

@Component({
  selector: 'blocked-account',
  templateUrl: './blocked-account.component.html',
  styleUrls: ['./blocked-account.component.scss'],
})
export class BlockedAccountComponent {
  contacts: LocalizeContacts;

  constructor(configService: ConfigService) {
    this.contacts = configService.localizeContacts;
  }
}
